import { useTranslation } from 'react-i18next';
import { CrmSignupCard } from './CrmSignupCard';
import { CrmIntegratedManagement } from './CrmIntegratedManagement';
import { CrmManagement } from './CrmManagement';

export default function CrmDetails() {
    const { t } = useTranslation();

    return (
        <div className="mt-[86px] mainContainer">
            <div className="flex flex-col gap-10">
                <CrmManagement
                    title={t('crmPage.details.ems.title')}
                    description={t('crmPage.details.ems.description')}
                    id="ems"
                />

                <CrmIntegratedManagement
                    icon="attendance"
                    title={t('crmPage.details.gms.title')}
                    description={t('crmPage.details.gms.description')}
                    id="gms"
                />

                <CrmManagement
                    icon="recruitment"
                    title={t('crmPage.details.hms.title')}
                    description={t('crmPage.details.hms.description')}
                    id="hms"
                />

                <CrmIntegratedManagement
                    title={t('crmPage.details.rms.title')}
                    description={t('crmPage.details.rms.description')}
                    id="rms"
                />
            </div>
            <CrmSignupCard />
        </div>
    );
}
